import { reactive } from "@vue/composition-api";
import _axios from "@/axios";

export function usePMSTransaction() {
  let pmsTransactionData = reactive({
    transactions: [],
    firstLoad: true,
    isLoading: false,
  });

  function listPMSTransactions(page = 1) {
    pmsTransactionData.isLoading = true;

    const params = new URLSearchParams({
      page: page,
    });

    return _axios
      .get("/list-transaction-pms?" + params.toString())
      .then((response) => {
        pmsTransactionData.transactions = response.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      })
      .finally(() => {
        pmsTransactionData.isLoading = false;
        pmsTransactionData.firstLoad = false;
      });
  }

  return {
    listPMSTransactions,
    pmsTransactionData,
  };
}
